module.exports = __webpack_public_path__ + "img/l_sq.80b73313.png";